<template>
    <div class="python">
        <Header></Header>
        <iframe id="pyIframe" :src="ifreamSrc" scrolling="no" width="100%" @load="changeFrameHeight" frameborder="0"></iframe>
    </div>
</template>
<script>
import Header from '@/components/header';

export default {
    components: { Header },
    data() {
        return {
            hostName: location.hostname,
            ifreamSrc: "",
            contentWindow: null,
        }
    },
    created() {
        if(this.$route.query && this.$route.query.lessonId) {
            this.ifreamSrc = `https://${this.hostName}/python?lessonId=${this.$route.query.lessonId}`;
        } else if(this.$route.query && this.$route.query.id) {
            this.ifreamSrc = `https://${this.hostName}/python?worksId=${this.$route.query.id}`;
        } else {
            this.ifreamSrc = `https://${this.hostName}/python`;
        }
    },
    mounted() {
        window.onresize = () => {
            this.changeFrameHeight()
        };
    },
    beforeRouteLeave (to, from, next) {
        this.$confirm('离开页面会导致未保存的程序丢失，确定离开？', '提示', {
            confirmButtonText: '离开',
            cancelButtonText: '等一下，去保存',
            type: 'warning',
            closeOnClickModal: false,
            showClose: false
        }).then(() => {
            next();
        }).catch(() => {
                  
        });
    },
    beforeDestroy() {
        window.onresize = "";
    },
    methods: {
        changeFrameHeight() {
            var frm = document.getElementById('pyIframe');
            frm.height = document.documentElement.clientHeight;
            this.setPythonStatus();
        },
        //初始化contentWindow
        setPythonStatus() {
            this.contentWindow = document.getElementById('pyIframe').contentWindow;
            this.$store.commit('setPythonLogin', this.contentWindow.pylogin);
        },
    }
}
</script>
<style scoped>
.python {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}
#pyIframe {
    height: calc(100vh - 51px);
    min-width: 1024px;
    min-height: 640px;
}
</style>


// WEBPACK FOOTER //
// src/views/python/python.vue